import React, { useEffect, useRef, useState } from "react"
import { get } from "helpers/api_helper"
import { invalidateEventCache } from "pages/EventsManagement/eventCachePolicy"
import EventCompletionStatus, { verifiedCompletion } from "./EventCompletionStatus"

// The competition's page holds only its own competition: a Tenis10 blocker naming another one is named from the event's competition
// directory, read once, only then; a directory that cannot be read leaves the blocker named by its game type.
const useBlockerCompetitions = (eventId, data, competitions = [], tenis10) => {
  const [directory, setDirectory] = useState({ eventId: null, competitions: [] })
  const unknown = tenis10 && (data?.blockers || []).some(blocker => blocker.competitionId && !competitions.some(item => item?._id === blocker.competitionId))
  const read = directory.eventId === eventId
  useEffect(() => {
    if (!unknown || read) return undefined
    let current = true
    get(`/admin/events/${eventId}/competition-directory`)
      .then(response => { if (current) setDirectory({ eventId, competitions: response?.data?.competitions || [] }) })
      .catch(() => { if (current) setDirectory({ eventId, competitions: [] }) })
    return () => { current = false }
  }, [eventId, unknown, read])
  return read ? [...competitions, ...directory.competitions] : competitions
}

export default function EventCompletion({ eventId, refreshKey, onCompleted, timezone, tenis10 = false, competitions }) {
  const [state, setState] = useState({ loading: true })
  const [refresh, setRefresh] = useState(0)
  const completed = useRef(null), callback = useRef(onCompleted)
  callback.current = onCompleted
  useEffect(() => {
    let current = true, timer
    const read = () => {
      get(`/admin/event-completions/${eventId}`).then(({ data }) => {
        if (!verifiedCompletion(data, eventId)) throw new Error("Unverified event completion")
        if (!current) return
        setState({ data })
        if (data.status === "ended" && completed.current !== `${eventId}:${data.endedAt}`) {
          completed.current = `${eventId}:${data.endedAt}`
          invalidateEventCache({ eventId })
          callback.current?.()
        }
        if (data.status === "pending" || data.synchronization === "pending") timer = setTimeout(read, 5000)
      }).catch(() => { if (current) setState({ error: true }) })
    }
    setState({ loading: true }); read()
    return () => { current = false; clearTimeout(timer) }
  }, [eventId, refreshKey, refresh])
  const named = useBlockerCompetitions(eventId, state.data, competitions, tenis10)
  return <section className="mb-3" aria-label="Event completion">
    <div className="points-person-heading"><h3 className="h5 mb-0">Event completion</h3><button className="btn btn-light btn-sm" disabled={state.loading} onClick={() => setRefresh(value => value + 1)}>Check event status</button></div>
    {state.loading ? <p role="status">Checking event status…</p> : <EventCompletionStatus data={state.data} eventId={eventId} timezone={timezone} tenis10={tenis10} competitions={named} />}
  </section>
}
